module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"filter_income":"Filter income"},"id":{"filter_income":"Filter pendapatan"}}')
  delete Component.options._Ctor
}
